<div class="csv-imports">
  @if (!data) {
  <div class="content">
    <qa-csv-import-upload-area
      [cancelUploadLabels]="cancelUploadLabels"
      [uploadAreaParameters]="uploadAreaParameters"
      [title]="'common.label.importQuestionFromCSV' | translate"
      (cancelUpload)="onCancel($event)"
      (continueUpload)="onNext($event)"
    >
    </qa-csv-import-upload-area>
  </div>
  } @if (data) { @if (!showOverview) {
  <qa-content-spinner [active]="loading">
    @if (navigateForm) {
    <div class="question-form-wrapper">
      <ng-container *ngTemplateOutlet="title"> </ng-container>
      <div>
        <ng-container *ngTemplateOutlet="main"> </ng-container>
      </div>
    </div>
    }
  </qa-content-spinner>
  <ng-template #title> </ng-template>
  <ng-template #main>
    <qa-question-edit
      #questionEdit
      [importQuestion]="data?.csvData[currentItemIndex]"
      (importQuestionChange)="data.csvData[currentItemIndex] = $event"
      [isImport]="true"
      [importNavigation]="{
        count: data?.csvData?.length,
        index: currentItemIndex
      }"
      (importNavigate)="onNavigate($event)"
    >
      <div actionButtons>
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </div>
    </qa-question-edit>
  </ng-template>

  <ng-template #actions>
    <div class="action-buttons">
      <div class="accept">
        <mat-checkbox
          (change)="onChange($event)"
          (click)="$event.stopPropagation()"
          [(ngModel)]="isChecked"
          color="primary"
        >
        </mat-checkbox>
        <label>{{ 'common.label.accept' | translate }}</label>
      </div>
      <div class="flex-align-right d-flex">
        <qa-button
          class="mr-20"
          (submitted)="data = undefined"
          label="common.button.cancel"
        ></qa-button>
        <qa-button
          data-cy="overview"
          [isRaisedButton]="true"
          [disabled]="questionEdit?.form?.invalid"
          (submitted)="overviewData()"
          label="csvImports.toOverview"
          type="submit"
        ></qa-button>
      </div>
    </div>
  </ng-template>
  } @if (showOverview) {
  <div class="overview">
    <div class="csv-content">
      <mat-list>
        <mat-list-item class="list-item-header">
          <mat-checkbox
            class="check-all"
            color="primary"
            (change)="onSelectAll()"
            [checked]="!removedItemIdx.length"
            [ngClass]="{ 'selected-all': !removedItemIdx.length }"
          >
          </mat-checkbox>
          <div class="header-text">
            {{ 'question.table.text' | translate }}
          </div>
        </mat-list-item>

        <div
          class="question-list-wrapper"
          [style.height.px]="data?.csvData?.length * LIST_ITEM_HEIGHT"
        >
          <ng-scrollbar>
            @for (card of data?.csvData; track $index; let i = $index) {
            <mat-list-item class="question-list-items" (click)="editCard(i)">
              <mat-checkbox
                color="primary"
                (change)="onChange($event, i)"
                [checked]="!removedItemIdx.includes(i)"
                (click)="$event.stopPropagation()"
              >
              </mat-checkbox>
              <div class="item-position">
                {{ i + 1 }}
              </div>
              <div
                class="item-text"
                [ngClass]="{
                  success:
                    successQuestion.includes(i) && !removedItemIdx.includes(i),
                  fail:
                    failedQuestion.includes(i) && !removedItemIdx.includes(i)
                }"
              >
                <span class="question-type-short">
                  {{
                    (card.is_poll_question
                      ? 'question.label.surveyQuestionShort'
                      : 'question.label.quizQuestionShort'
                    ) | translate
                  }}
                  ({{ questionTypeDisplayFn(card.type, true) }})
                </span>
                <span class="question-text"> {{ card.text }}</span>
              </div>
            </mat-list-item>
            }
          </ng-scrollbar>
        </div>
      </mat-list>
    </div>
  </div>
  <div class="btn-action">
    <button
      color="primary"
      [disabled]="isComplete"
      (click)="back()"
      mat-button
      type="button"
    >
      <mat-icon>arrow_back</mat-icon> {{ 'common.button.back' | translate }}
    </button>
    <div class="flex-align-right d-flex import-btn">
      <qa-button
        class="mr-20"
        (submitted)="cancel()"
        [label]="isComplete ? 'common.button.done' : 'common.button.cancel'"
      ></qa-button>
      <qa-button
        [isRaisedButton]="true"
        [disabled]="
          isComplete ||
          inProgress ||
          removedItemIdx.length == data?.csvData?.length
        "
        (submitted)="importCsv()"
        data-cy="importAll"
        label="csvImports.importNow"
        type="submit"
      ></qa-button>
    </div>
  </div>
  } }
</div>
